import React from 'react';
import { FilterList, KeyboardArrowDown, LocationOn } from '@mui/icons-material';
import { Box } from '@mui/material';
import { AutoGrid, Button } from 'c-components';
import { Translate, useCommonTranslation } from 'c-translation';
import type { PCAViewControlProps } from './types';
import TypeSwitcher from './TypeSwitcher';
import FieldSwitcher from './FieldSwitcher';
import DataStatusSelector from './DataStatusSelector';
import { ReportView } from '../types';
// import SearchInput from './SearchInput';

type Props = PCAViewControlProps;

const PCAViewControls: React.FC<Props> = ({
    view,
    onViewChange,
    // searchValue,
    // onSearchValueUpdated,
    type,
    onTypeChange,
    metric,
    field,
    fields,
    onFieldSwitch,
    onFieldsSwitch,
    showAdvancedFilters,
    filtersCount,
    isDsp,
    showUnitId,

    removeMapView,
    removeOverallView,
    typeSwitcherDisabled = false,

    notices,
    onDataStatusChange,
    dataStatus,
    extraControls,
}) => (
    // const showSearch = useMemo(
    //     () => view === ReportView.Field && type === FieldReportType.OverallLeaderboard,
    //     [view, type],
    // );
    <>
        {/* {showSearch && ( */}
        {/*    <SearchInput */}
        {/*        searchValue={searchValue} */}
        {/*        onSearchValueUpdated={onSearchValueUpdated} */}
        {/*    /> */}
        {/* )} */}
        <Box ml="auto">
            <AutoGrid spacing={2}>
                {notices.length > 0 && (
                    <DataStatusSelector
                        notices={notices}
                        onDataStatusChange={onDataStatusChange}
                        dataStatus={dataStatus}
                    />
                )}
                {extraControls}
                <Button
                    onClick={showAdvancedFilters?.toggle}
                    color={filtersCount > 0 ? 'primary' : 'secondary'}
                    className="pca-filter-by"
                >
                    <FilterList sx={{ mr: 0.5 }} />
                    {useCommonTranslation('Modules.Main.Campaigns.Overview.Reports.filterBy')}
                    <KeyboardArrowDown />
                </Button>
                <FieldSwitcher
                    field={field}
                    fields={fields}
                    metric={metric}
                    onFieldSwitch={onFieldSwitch}
                    onFieldsSwitch={onFieldsSwitch}
                    view={view}
                    onViewChange={onViewChange}
                    removeOverallView={removeOverallView}
                    isDsp={isDsp}
                    showUnitId={showUnitId}
                />

                <TypeSwitcher
                    type={type}
                    onTypeChange={onTypeChange}
                    field={field}
                    view={view}
                    disabled={typeSwitcherDisabled}
                />
                {!removeMapView && (
                    <Button
                        color={view === ReportView.Map ? 'primary' : 'secondary'}
                        onClick={() => onViewChange(ReportView.Map)}
                        sx={{ display: 'flex', alignItems: 'center' }}
                        className="pca-map"
                    >
                        <LocationOn sx={{ mr: 0.5 }} />
                        <Translate path="Modules.Main.Campaigns.Overview.Reports.byMap" />
                    </Button>
                )}
            </AutoGrid>
        </Box>
    </>
);
export default PCAViewControls;
